import { render } from "./HelpCenterView.vue?vue&type=template&id=45a81592&scoped=true"
import script from "./HelpCenterView.vue?vue&type=script&lang=js"
export * from "./HelpCenterView.vue?vue&type=script&lang=js"

import "./HelpCenterView.vue?vue&type=style&index=0&id=45a81592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a81592"]])

export default __exports__